module.exports = __webpack_public_path__ + "static/template-rectangle-7c94d94eaef4f964a20c936233d7500b.png";